/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Amount } from './Amount';
// @ts-ignore
import {
// @ts-ignore
    AmountFromJSON,
// @ts-ignore
    AmountFromJSONTyped,
// @ts-ignore
    AmountToJSON,
} from './Amount';
// @ts-ignore
import type { Discount } from './Discount';
// @ts-ignore
import {
// @ts-ignore
    DiscountFromJSON,
// @ts-ignore
    DiscountFromJSONTyped,
// @ts-ignore
    DiscountToJSON,
} from './Discount';
// @ts-ignore
import type { Status } from './Status';
// @ts-ignore
import {
// @ts-ignore
    StatusFromJSON,
// @ts-ignore
    StatusFromJSONTyped,
// @ts-ignore
    StatusToJSON,
} from './Status';
// @ts-ignore
import type { TimeWindow } from './TimeWindow';
// @ts-ignore
import {
// @ts-ignore
    TimeWindowFromJSON,
// @ts-ignore
    TimeWindowFromJSONTyped,
// @ts-ignore
    TimeWindowToJSON,
} from './TimeWindow';

/**
 * 
 * @export
 * @interface PromotionCreateRequest
 */
export interface PromotionCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof PromotionCreateRequest
     */
    name: string;
    /**
     * 
     * @type {TimeWindow}
     * @memberof PromotionCreateRequest
     */
    effectivePeriod?: TimeWindow;
    /**
     * 
     * @type {Array<Discount>}
     * @memberof PromotionCreateRequest
     */
    discounts: Array<Discount>;
    /**
     * 
     * @type {string}
     * @memberof PromotionCreateRequest
     */
    currencyCode: string;
    /**
     * 
     * @type {Amount}
     * @memberof PromotionCreateRequest
     */
    minimumAmount?: Amount;
    /**
     * 
     * @type {number}
     * @memberof PromotionCreateRequest
     */
    minimumQuantity: number;
    /**
     * 
     * @type {string}
     * @memberof PromotionCreateRequest
     */
    supplierId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PromotionCreateRequest
     */
    retailerIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PromotionCreateRequest
     */
    storeIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PromotionCreateRequest
     */
    productCategoryId?: string;
    /**
     * 
     * @type {string}
     * @memberof PromotionCreateRequest
     */
    productListId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PromotionCreateRequest
     */
    skuIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof PromotionCreateRequest
     */
    allProducts?: boolean;
    /**
     * 
     * @type {Status}
     * @memberof PromotionCreateRequest
     */
    status: Status;
}

/**
 * Check if a given object implements the PromotionCreateRequest interface.
 */
// @ts-ignore
export function instanceOfPromotionCreateRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "discounts" in value;
    isInstance = isInstance && "currencyCode" in value;
    isInstance = isInstance && "minimumQuantity" in value;
    isInstance = isInstance && "supplierId" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

// @ts-ignore
export function PromotionCreateRequestFromJSON(json: any): PromotionCreateRequest {
    return PromotionCreateRequestFromJSONTyped(json, false);
}

// @ts-ignore
export function PromotionCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromotionCreateRequest {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'effectivePeriod': !exists(json, 'effective_period') ? undefined : TimeWindowFromJSON(json['effective_period']),
        'discounts': ((json['discounts'] as Array<any>).map(DiscountFromJSON)),
        'currencyCode': json['currency_code'],
        'minimumAmount': !exists(json, 'minimum_amount') ? undefined : AmountFromJSON(json['minimum_amount']),
        'minimumQuantity': json['minimum_quantity'],
        'supplierId': json['supplier_id'],
        'retailerIds': !exists(json, 'retailer_ids') ? undefined : json['retailer_ids'],
        'storeIds': !exists(json, 'store_ids') ? undefined : json['store_ids'],
        'productCategoryId': !exists(json, 'product_category_id') ? undefined : json['product_category_id'],
        'productListId': !exists(json, 'product_list_id') ? undefined : json['product_list_id'],
        'skuIds': !exists(json, 'sku_ids') ? undefined : json['sku_ids'],
        'allProducts': !exists(json, 'all_products') ? undefined : json['all_products'],
        'status': StatusFromJSON(json['status']),
    };
}

// @ts-ignore
export function PromotionCreateRequestToJSON(value?: PromotionCreateRequest | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'effective_period': TimeWindowToJSON(value.effectivePeriod),
        'discounts': ((value.discounts as Array<any>).map(DiscountToJSON)),
        'currency_code': value.currencyCode,
        'minimum_amount': AmountToJSON(value.minimumAmount),
        'minimum_quantity': value.minimumQuantity,
        'supplier_id': value.supplierId,
        'retailer_ids': value.retailerIds,
        'store_ids': value.storeIds,
        'product_category_id': value.productCategoryId,
        'product_list_id': value.productListId,
        'sku_ids': value.skuIds,
        'all_products': value.allProducts,
        'status': StatusToJSON(value.status),
    };
}

